export const getSiblingUrl = (
  activeTabPathname: string | undefined,
  nextResourceRootPathname: string
): string => {
  if (!activeTabPathname) {
    return nextResourceRootPathname
  }

  const currentTabChunks = activeTabPathname.split('/')
  const newResourceChunks = nextResourceRootPathname.split('/')

  return newResourceChunks.concat(currentTabChunks.slice(newResourceChunks.length)).join('/')
}
